import React from 'react'
import ReactDOM from 'react-dom'
import { AppContainer } from 'react-hot-loader'
import { launch } from '@sencha/ext-react'
import { ExtReact } from '@sencha/ext-react'
import * as d3 from 'd3'
window.d3 = d3

import './App.scss'
import '../components/Layout/requireExt'

// require('../ext-locale-zh_CN')
// import('../ext-locale-zh_CN')


Ext.onReady(() => {
	Ext.Msg.defaultAllowedConfig.showAnimation = false
	Ext.Msg.defaultAllowedConfig.hideAnimation = false
})

let viewport;

const render = (Component, target) => {
	ReactDOM.render(
		<ExtReact>
			<AppContainer>
				<Component />
			</AppContainer>
		</ExtReact>,
		target
	)
}

const start = ({ App, title, systemName, companyName, ...props }) => {
	title && (title = Tyan.t(title))
	systemName && (systemName = Tyan.t(systemName))
	companyName && (companyName = Tyan.t(companyName))

	document.title = title

	launch(
		() => {
			let top = Ext.get('loadingSplashTop'), wrapper = Ext.get('loadingSplash')
			top.on('transitionend', wrapper.destroy, wrapper, { single: true })
			wrapper.addCls('app-loaded')
			return <ExtReact>
				<App {...{ systemName, companyName, ...props }} />
			</ExtReact>
		},
		{ debug: false },
		{
			quickTips: {
				tooltip: {
					dismissDelay: 0,
					anchor: true,
					allowOver: true,
					maxHeight: '90%',
					maxWidth: '90%',
					scrollable: true,
					// show qtips on tap on mobile
					showOnTap: true
				},
				overflowTip: {
					// This means that mouseover (or a touch)
					// cancels the auto dismiss timer to give the
					// user an opportunity to read long text.
					// Tap outside of the tip then closes it.
					allowOver: true
				}
			}
		}
	)

	if (module.hot) {
		module.hot.accept('.', () => render(App, viewport));
	}
}

export { default as AppMain } from './AppMain'
export default start